// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mCR6","footer":"styles_footer__3XIxG","passCodeTooltip":"styles_passCodeTooltip__3VMvZ"};